import type { InputHTMLAttributes } from 'react';
import classnames from 'classnames';
import styles from './Slider.module.scss';

type SliderProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function Slider({ className, ...inputProps }: SliderProps): JSX.Element {
  return (
    <input
      type="range"
      className={classnames(styles.slider, className)}
      {...inputProps}
    />
  );
}
